
            const data = {"name":"glyph/16/small-triangle-down-white","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"m3 5 5 6 5-6z\" class=\"nc-icon-wrapper\" _fill=\"#fff\"/>","originalColors":[{"type":"fill","color":"#fff"}],"stopColors":[]}}
        
                    module.exports = data
                    